import React from 'react';
import {
  ChatRequestModalOverlay,
  ChatRequestModalContent,
  ChatRequestModalHeader,
  ChatRequestModalTitle,
  ChatRequestModalCloseButton,
  ChatRequestModalButtons,
  ChatRequestModalButton,
  DeleteChatModalDescription,
} from '../../../styles/UserWorkspacePageStyles';
import { useT } from '../../../LocaleContext';

const DeleteMessageModal = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const t = useT();

  if (!isOpen) return null;

  return (
    <ChatRequestModalOverlay onClick={onClose}>
      <ChatRequestModalContent onClick={(e) => e.stopPropagation()}>
        <ChatRequestModalHeader>
          <ChatRequestModalTitle>{t('modals.deleteMessage')}</ChatRequestModalTitle>
          <ChatRequestModalCloseButton onClick={onClose}>
            ×
          </ChatRequestModalCloseButton>
        </ChatRequestModalHeader>
        <div style={{ marginBottom: '20px' }}>
          <DeleteChatModalDescription>
            {t('modals.deleteMessageConfirm')}
          </DeleteChatModalDescription>
        </div>
        <ChatRequestModalButtons>
          <ChatRequestModalButton onClick={onClose}>
            {t('common.cancel')}
          </ChatRequestModalButton>
          <ChatRequestModalButton onClick={onConfirm} $danger>
            {t('common.delete')}
          </ChatRequestModalButton>
        </ChatRequestModalButtons>
      </ChatRequestModalContent>
    </ChatRequestModalOverlay>
  );
};

export default DeleteMessageModal;
